module.exports = __webpack_public_path__ + "img/create-employee.6d102b3f.png";